import React, { useState } from "react";

export default function Currency({ children, className }) {
  const [showCurrency] = useState(true);

  return showCurrency ? (
    <span className={className}>
      {children === "ETBB" ? (children = "ETB") : children}
    </span>
  ) : null;
}
